import React, { useEffect } from "react";
import { Country } from "country-state-city";
import { focusOnFirstError } from "./focusUtils";
import Select from "react-select";

const employers = [
  "Fortune 500 / Large Multinational Corporation (MNC)",
  "Mid-Sized Enterprise (500–5000 Employees)",
  "Small & Medium Enterprise (SME) (<500 Employees)",
  "Startup / Early-Stage Company",
  "Government / Public Sector",
  "Non-Profit / NGO",
  "Education & Research (School, University, R&D)",
  "Freelancer / Self-Employed / Consultant",
  "Not Employed",
].map((employ) => ({ label: employ, value: employ }));

const roles = [
  "Not Applicable",
  "Freelancer / Self-Employed / Entrepreneur",
  "Research & Education",
  "Creative & Design",
  "Sales & Marketing",
  "Business & Strategy",
  "Technical / Engineering",
  "Managerial",
  "Executive / C-Suite",
  "Public Service",
].map((role) => ({ value: role, label: role }));

const experience = [
  "0 - 2 years",
  "3 - 5 years",
  "6 - 10 years",
  "10 + years",
  "Student / Fresher",
].map((exp) => ({ label: exp, value: exp }));

const Options = ["College", "Friend", "Social Media", "Others"].map((opt) => ({
  value: opt,
  label: opt,
}));

const EmploymentForm = ({
  formValues,
  setFormValues,
  formErrors,
  setFormErrors,
  inputRefs,
  careerLaunch,
  customSelectStyles,
}) => {
  const countries = Country.getAllCountries();
  const countryOptions = countries.map((country) => ({
    value: country.isoCode,
    label: country.name,
  }));

  useEffect(() => {
    if (careerLaunch) {
      setFormValues((prev) => ({
        ...prev,
        current_employer: "Not Employed",
        currentRole: "Not Applicable",
        gender: "Student / Fresher",
      }));
    }
  }, [careerLaunch, setFormValues]);

  const validateField = (name, value) => {
    const errors = {};
    const requiredFields = careerLaunch
      ? ["desired_employer", "desiredRole", "desired_country"]
      : [
          "current_employer",
          "currentRole",
          "desired_employer",
          "desiredRole",
          "desired_country",
          "gender",
        ];

    if (requiredFields.includes(name) && !value) {
      errors[name] = `${name.replace(/_/g, " ")} is required`;
    }

    return errors;
  };

  const handleSelectChange = (selectedOption, { name }) => {
    const value = selectedOption ? selectedOption.value : "";
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    const fieldErrors = validateField(name, value);
    setFormErrors((prev) => ({
      ...prev,
      [name]: fieldErrors[name] || "",
    }));

    if (Object.keys(fieldErrors).length > 0) {
      focusOnFirstError(fieldErrors, inputRefs);
    }
  };

  return (
    <>
      <div
        className="form-section card responsive-card p-3"
        style={{ overflowY: "auto" }}
      >
        <h5 className="mb-3">Desired Employment</h5>
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
            <label className="small-label fw-bold">Desired Employer *</label>
            <Select
              ref={inputRefs.desired_employer}
              name="desired_employer"
              options={employers}
              onChange={(option) =>
                handleSelectChange(option, { name: "desired_employer" })
              }
              value={
                employers.find(
                  (option) => option.value === formValues.desired_employer
                ) || null
              }
              placeholder="Select Your Desired Employer"
              styles={customSelectStyles}
              classNamePrefix="select"
              className="form-control-select"
              isSearchable
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
            {formErrors.desired_employer && (
              <p className="text-red">{formErrors.desired_employer}</p>
            )}
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
            <label className="small-label fw-bold">Desired Role *</label>
            <Select
              ref={inputRefs.desiredRole}
              name="desiredRole"
              options={roles}
              onChange={(option) =>
                handleSelectChange(option, { name: "desiredRole" })
              }
              value={
                roles.find(
                  (option) => option.value === formValues.desiredRole
                ) || null
              }
              placeholder="Select Your Desired Role"
              styles={customSelectStyles}
              classNamePrefix="select"
              className="form-control-select"
              isSearchable
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
            {formErrors.desiredRole && (
              <p className="text-red">{formErrors.desiredRole}</p>
            )}
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
            <label className="small-label fw-bold">
              Desired Location Country *
            </label>
            <Select
              ref={inputRefs.desired_country}
              name="desired_country"
              options={countryOptions}
              onChange={(option) =>
                handleSelectChange(option, { name: "desired_country" })
              }
              value={
                countryOptions.find(
                  (option) => option.value === formValues.desired_country
                ) || null
              }
              placeholder="Select Desired Country"
              styles={customSelectStyles}
              classNamePrefix="select"
              className="form-control-select"
              isSearchable
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
            {formErrors.desired_country && (
              <p className="text-red">{formErrors.desired_country}</p>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 mb-1">
            <label className="small-label fw-bold">
              How did you hear about CLIF AI?
            </label>
            <Select
              name="clif_info"
              options={Options}
              onChange={(option) =>
                handleSelectChange(option, { name: "clif_info" })
              }
              value={Options.find(
                (option) => option.value === formValues.clif_info
              )}
              placeholder="How did you hear about CLIF AI?"
              styles={customSelectStyles}
              classNamePrefix="select"
              className="form-control-select"
              isSearchable
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EmploymentForm;
